import { render, staticRenderFns } from "./PatientLabels.vue?vue&type=template&id=8d21495a&scoped=true&lang=pug"
import script from "./PatientLabels.vue?vue&type=script&lang=js"
export * from "./PatientLabels.vue?vue&type=script&lang=js"
import style0 from "./PatientLabels.vue?vue&type=style&index=0&id=8d21495a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d21495a",
  null
  
)

export default component.exports